import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  contentChild,
  ElementRef,
  HostBinding,
  output,
  viewChild,
} from '@angular/core';
import { TableHeaderRowComponent } from './table-header-row.component';

/*
 * Approach of a general table component which creates a table with a scrollable body and a fixed header.
 * It uses the given header row and body rows to automatically determine the necessary column widths
 * and apply them into the fixed table layout.
 * */
@Component({
  selector: 'shared-core-table',
  templateUrl: './table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class TableComponent implements AfterViewInit {
  readonly bodyTable = viewChild<ElementRef<HTMLTableElement>>('bodyTable');
  readonly headerTable = viewChild<ElementRef<HTMLTableElement>>('headerTable');
  readonly headerRow = contentChild(TableHeaderRowComponent);

  tableCreated = output();

  @HostBinding('class')
  class = 'h-full w-full';

  ngAfterViewInit() {
    const bodyTable = this.bodyTable()?.nativeElement;
    const headerTable = this.headerTable()?.nativeElement;
    const headerRow = this.headerRow()?.element;

    if (!bodyTable) return;
    if (!headerTable) return;
    if (!headerRow) return;

    const firstRow = bodyTable.querySelector('tr')!;
    const columns = [...firstRow.querySelectorAll('td')];

    const columnWidth = columns.map((column) => column.getBoundingClientRect().width);

    bodyTable.querySelectorAll('tr').forEach((tr) => {
      tr.querySelectorAll('td').forEach((td, index) => {
        td.style.width = `${columnWidth[index]}px`;
        td.classList.add('text-nowrap');
      });
    });

    headerTable.appendChild(headerRow);

    bodyTable.classList.remove('table-auto');
    bodyTable.classList.add('table-fixed');
    headerTable.classList.remove('table-auto');
    headerTable.classList.add('table-fixed');

    this.tableCreated.emit();
  }
}
